import { Component, signal, OnInit, OnDestroy, NgZone } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import {ThemeService} from './core/services/theme.service';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgxSpinnerModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('eventz-ui');
  private spinnerWatchdogId: any = null;
  private routeSub: Subscription | null = null;

  constructor(
    private themeService: ThemeService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private zone: NgZone
  ) {
    this.themeService.initTheme();
  }

  ngOnInit(): void {
    // Force-hide spinner on every route navigation to prevent stale overlays
    this.routeSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.spinner.hide();
        this.clearStuckOverlays();
      });

    // Spinner watchdog: periodically check for stuck overlays every 3s
    this.zone.runOutsideAngular(() => {
      this.spinnerWatchdogId = setInterval(() => {
        this.clearStuckOverlays();
      }, 3000);
    });
  }

  ngOnDestroy(): void {
    if (this.spinnerWatchdogId) {
      clearInterval(this.spinnerWatchdogId);
    }
    this.routeSub?.unsubscribe();
  }

  /**
   * Removes any stuck spinner overlay elements from the DOM.
   * This handles the edge case where spinner.hide() fires but
   * the DOM overlay element retains display/pointer-events.
   */
  private clearStuckOverlays(): void {
    const overlays = document.querySelectorAll('ngx-spinner .overlay');
    overlays.forEach((el: Element) => {
      const htmlEl = el as HTMLElement;
      const computedStyle = window.getComputedStyle(htmlEl);
      const isVisible = computedStyle.display !== 'none' &&
                        computedStyle.visibility !== 'hidden' &&
                        parseFloat(computedStyle.opacity) > 0;

      // If overlay is visible but doesn't have the Angular .show class,
      // it's stuck — force hide it
      if (isVisible && !htmlEl.classList.contains('show')) {
        htmlEl.style.display = 'none';
        htmlEl.style.pointerEvents = 'none';
      }
    });
  }
}
